<form #form="ngForm">
    <ng-container *ngIf="customDeductionType">
        <div class="responsive-grid">
            <mat-form-field class="columns-10 small-columns-12">
                <mat-label>{{ 'components.request-custom-deduction-type.deductionName' | translate }}</mat-label>
                <input
                    type="text"
                    name="name"
                    required
                    #name="ngModel"
                    [(ngModel)]="customDeductionType.name"
                    placeholder="{{ 'components.request-custom-deduction-type.deductionNamePlaceholder' | translate }}"
                    matInput
                />
                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-10">
                <mat-label appRemoveAriaOwns>{{
                    'components.request-custom-deduction-type.selectT4Box' | translate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'components.request-custom-deduction-type.selectOptions' | translate }}"
                    multiple
                    name="t4BoxSelect"
                    #t4BoxSelect="ngModel"
                    [(ngModel)]="selectedT4Boxes"
                >
                    <mat-option *ngFor="let t4BoxOption of t4BoxService.t4BoxOptions" [value]="t4BoxOption.boxNumber">
                        {{ 'components.request-custom-benefit-type.box' | translate: { code: t4BoxOption.boxNumber } }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="columns-10">
                <mat-label appRemoveAriaOwns>{{
                    'components.request-custom-deduction-type.selectRl1Box' | translate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'components.request-custom-deduction-type.selectRl1Options' | translate }}"
                    multiple
                    name="rl1BoxSelect"
                    #rl1BoxSelect="ngModel"
                    [(ngModel)]="selectedRl1Boxes"
                >
                    <mat-option *ngFor="let rl1BoxOption of rl1BoxService.rl1BoxOptions" [value]="rl1BoxOption.code">
                        {{ 'components.request-custom-deduction-type.box' | translate: { code: rl1BoxOption.code } }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <h5 class="align-left margin-bottom-1">
                {{ 'components.request-custom-deduction-type.employeeContribution' | translate }}
            </h5>
            <mat-checkbox
                class="columns-12 align-left"
                name="employeePretax"
                [(ngModel)]="customDeductionType.employeePretax"
                >{{ 'components.request-custom-deduction-type.preTax' | translate }}</mat-checkbox
            >
        </div>
    </ng-container>
</form>
